export default {
    overflowX: 'hidden',
};
